import styled from "styled-components";

export const MainNavMenuBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 1.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.5);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.8);
  }
`